import React, { Component } from 'react';
import Profilecomponent from '../../common/profilecomponent';
import CorteCajaContainer from './CorteCajaContainer';
import SweetAlert from 'sweetalert2-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import Dropzone from '../../common/DropzoneExample';

import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

import { Link } from "react-router-dom";



const mapStateToProps = (state) => {
	/*
	state.AlumnoReducer.getResponDataAlumno		= false;
	state.AlumnoReducer.errorResponDataAlumno	= false;
	state.AlumnoReducer.getAlumnoDetail			= false;
	state.AlumnoReducer.errorAlumnoDetail		= false;
	state.AlumnoReducer.getResponDataAlumnoC	= false;
	state.AlumnoReducer.errorResponDataAlumnoC	= false;
	state.AlumnoReducer.getAlumnoBorrar			= false;
	state.AlumnoReducer.errorAlumnoBorrar		= false;

	return {
		getResponDataAlumno: state.AlumnoReducer.getResponDataAlumno,
		errorResponDataAlumno: state.AlumnoReducer.errorResponDataAlumno,
		getAlumnoDetail: state.AlumnoReducer.getAlumnoDetail,
		errorAlumnoDetail: state.AlumnoReducer.errorAlumnoDetail,
		getResponDataAlumnoC: state.AlumnoReducer.getResponDataAlumnoC,
		errorResponDataAlumnoC: state.AlumnoReducer.errorResponDataAlumnoC,
		getAlumnoBorrar: state.AlumnoReducer.getAlumnoBorrar,
		errorAlumnoBorrar: state.AlumnoReducer.errorAlumnoBorrar
	};
	*/
};


class CorteCaja extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			show: false,
		};
	}

	render() {
		const { activeTab } = this.state
		return (
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Corte Caja</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Administrativo</a></li>
									<li className="breadcrumb-item active" aria-current="page">Listar Colegiatura/Servicios Hoy</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">
								
							</Nav>

						</div>
					</div>
				</div>

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>

							<TabPane tabId={1} className={classnames(['fade show'])}>
								<CorteCajaContainer />
							</TabPane>

						</TabContent>
					</div>
				</div>

			</>
		);

	}//END RENDER


}//END CLASS

export default withRouter(connect(mapStateToProps, null)(CorteCaja));

